import React from 'react'
import { GetRoadHome } from "../components/newHome/GetRoadHome";
import packages from "../assets/images/test-packages.png";
import Progressive from "../components/progressive/Progressive";
import { GuideTestimonials } from "../components/newpages/guide/GuideTestimonials";
import PackageLesson from '../components/packagelesson/PackageLesson';
const TestPackages = () => {
  return (
    <>
    <GetRoadHome
        heading="Package Test/Lessons
"
        image={packages}
      />
      <PackageLesson/>
    </>
    
  )
}

export default TestPackages